import React from "react";
const DEFAULT_LOCALE = "en";
const LocaleContext = React.createContext(DEFAULT_LOCALE);
export default LocaleContext;
